import React, { useState } from 'react';
//import ContactCntrlr from "../Support/ContactCntrlr.js";
//import ContactUs from "../Support/ContactUs.js";
//import ContactUsDone from "../Support/ContactUsDone.js";
import HomeBtns from './HomeBtns.js';
import FamilyFarmDay from './FamilyFarmDay.js';
import PlanVisit from './PlanVisit.js';
import HoneyBees1 from './HoneyBees1';
import HoneyBees2 from './HoneyBees2';
import TearoomAd from './TearoomAd';
import './home.css';

function Home() {
  const [cntrlCom, setCntrlCom] = useState();

  function chgComponent(cmpnt) {
    setCntrlCom(cmpnt);
    console.log(cntrlCom);
  }
  /*return <ContactCntrlr setCntrlCom={setCntrlCom} />;
              case "planvisit":*/
  /*<div className="teaflex" style={{ marginBottom: "0px" }}>
          <img
            className="teaimage"
            style={{ width: "30em", height: "auto:" }}
            src={process.env.PUBLIC_URL + "/events/" + "teaservice.jpg"}
            alt="Tea Service"
          ></img>
        </div>*/
  return (
    <div className="homeTop">
      <div className="homeContainer">
        <div className="">
          <HomeBtns chgComponent={chgComponent} />
        </div>

        <div className="">
          {(() => {
            switch (cntrlCom) {
              case 'familyfarmday':
                return <FamilyFarmDay setCntrlCom={setCntrlCom} />;
              case 'planvisit':
                return <PlanVisit setCntrlCom={setCntrlCom} />;
              case 'honeyBees1':
                return <HoneyBees1 setCntrlCom={setCntrlCom} />;
              case 'honeyBees2':
                return <HoneyBees2 setCntrlCom={setCntrlCom} />;
              case 'teaRoomMgr':
                return <TearoomAd setCntrlCom={setCntrlCom} />;
              default:
                return null;
            }
          })()}
        </div>
      </div>
    </div>
  );
}

export default Home;
